
export enum VehicleStatusEnum {

    None = 0,
    Moving = 1,
    Parked = 2,
    NoGPS = 3,
    NoGSM = 4,
    Disconnected = 5,
    Towed = 6,
}
